/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
import axios from 'axios';
import { toast } from 'react-toastify';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Row,
  Col,
  Form,
  Image,
  Table,
  Modal,
  Button,
  Container,
  FormControl,
} from 'react-bootstrap';

import { declineUser, getUsersState } from 'reducers/usersReducer';

import './Decline.scss';

const Decline = ({ show, handleClose, data, handleUsers }) => {
  const dispatch = useDispatch();

  const userData = useSelector(getUsersState);
  const { declineLogs } = userData;

  const [formData, setFormData] = useState({
    roles: [],
    reason: '',
  });

  const handleChange = (e) => {
    const { value, name } = e.target;

    setFormData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const handleSave = async () => {
    if (formData?.reason === '') {
      toast.error('Please select role');
      return;
    }

    const objData = {
      id: data?.id,
      params: { decline_reason: formData?.reason },
    };

    try {
      const response = await dispatch(declineUser(objData));

      if (response) {
        handleUsers();
        handleClose();
        toast.info('Successfully declined user');
      }

      setFormData((prev) => ({ ...prev, reason: '' }));
    } catch (error) {
      toast.error(error);
    }
  };

  useEffect(() => {
    const getRoles = async () => {
      try {
        axios.get('api/roles').then((response) => {
          setFormData((prev) => ({ ...prev, roles: response?.data?.data }));
        });
      } catch (error) {
        console.log('Error', error);
      }
    };

    getRoles();
  }, []);

  return (
    <Modal show={show} onHide={handleClose} centered className='updateRoles'>
      <Modal.Header closeButton>
        <Modal.Title>Decline Account</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='body'>
          <Row className='w-100'>
            <Col>
              <Form.Group className='mb-4 group'>
                <Form.Label>Decline Reason</Form.Label>
                <Form.Control
                  name='reason'
                  onChange={handleChange}
                  placeholder='Enter Here'
                  value={formData?.reason}
                />
              </Form.Group>

              <Form.Group className='group'>
                <Button
                  onClick={handleSave}
                  className='updateRoles'
                  disabled={declineLogs?.isLoading}
                >
                  Save
                </Button>
              </Form.Group>
            </Col>
          </Row>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default Decline;
